import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import SignUp from "@/business/pages/SignUp";
import Login from "@/business/pages/Login";
import BusinessProfile from "@/business/pages/BusinessProfile";
import DashboardLayout from "@/business/pages/dashboard/Layout";
import Overview from "@/business/pages/dashboard/Overview";
import Venue from "@/business/pages/dashboard/Venue";
import Hire from "@/business/pages/dashboard/Hire";
import Gigs from "@/business/pages/dashboard/Gigs";
import NotificationsPage from "@/business/pages/dashboard/Notifications";
import MessagesPage from "@/business/pages/dashboard/Messages";
import SettingsPage from "@/business/pages/dashboard/Settings";

/**
 * The CRA bundle is loaded on every page (marketing + business). For
 * marketing routes, the static HTML in public/index.html handles rendering
 * and this React app simply returns null.
 *
 * For /business/* routes, the inline script in index.html sets
 * <html data-route="business">, which causes CSS to hide the static
 * marketing DOM and expose <div id="root"> where this app mounts.
 */
function App() {
  if (typeof window === "undefined") return null;
  const path = window.location.pathname || "";
  const isBusiness = path === "/business" || path === "/business/" || path.startsWith("/business/");
  if (!isBusiness) return null;

  return (
    <BrowserRouter>
      <Toaster position="top-right" richColors closeButton />
      <Routes>
        <Route path="/business" element={<Navigate to="/business/login" replace />} />
        <Route path="/business/signup" element={<SignUp />} />
        <Route path="/business/login" element={<Login />} />
        <Route path="/business/dashboard" element={<DashboardLayout />}>
          <Route index element={<Overview />} />
          <Route path="venue" element={<Venue />} />
          <Route path="hire" element={<Hire />} />
          <Route path="gigs" element={<Gigs />} />
          <Route path="notifications" element={<NotificationsPage />} />
          <Route path="messages" element={<MessagesPage />} />
          <Route path="settings" element={<SettingsPage />} />
        </Route>
        {/* Public business profile — keep LAST so /signup, /login, /dashboard
            match their specific routes first. Anything else under
            /business/:username is treated as a public profile lookup. */}
        <Route path="/business/:username" element={<BusinessProfile />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
